export function findScrollTargetElement(
  containerEl: HTMLElement,
  pageNumber: string,
  anchor?: string,
): HTMLElement | null {
  const pageSelector = `[data-citation-page="${pageNumber}"]`

  if (anchor) {
    const pageAndAnchorMatch = containerEl.querySelector<HTMLElement>(`${pageSelector} #${CSS.escape(anchor)}`)
    if (pageAndAnchorMatch) {
      return pageAndAnchorMatch
    }

    return containerEl.querySelector<HTMLElement>(`[data-body] #${CSS.escape(anchor)}`)
  }

  return containerEl.querySelector<HTMLElement>(pageSelector)
}
